import React from 'react'

function PromptAssistant() {
  return (
    <div>PromptAssistant</div>
  )
}

export default PromptAssistant
